import type { Item } from '@/components/blocks/UsePassDialog';
import type { Tables } from '@/types/database.types';

export type Promocode = Tables<'promocodes'> & { gift_target_ticket_id?: string | null };

export const isPromocodeEligibleItem = (item: Item) =>
    Boolean(
        item.ticket.usage_limits.single_use &&
            (item.ticket.usage_limits.online >= 1 || item.ticket.usage_limits.in_cinema >= 1) &&
            !item.usedPassId &&
            !item.ticket.is_gift,
    );

export function isTargetedGiftCart(items: Item[], promocode: Promocode): boolean {
    if (!promocode.gift_target_ticket_id || items.length !== 1) return false;
    const item = items[0];
    return (
        item.ticket.id === promocode.gift_target_ticket_id &&
        item.ticket.festival_id === promocode.festival_id &&
        item.quantity === 1 &&
        !item.screening &&
        !item.ticket.is_gift &&
        !item.usedPassId &&
        !item.passQuantityUsed
    );
}

export function getPromocodeItems(items: Item[], promocode: Promocode | null): Item[] {
    if (promocode?.gift_target_ticket_id) {
        return isTargetedGiftCart(items, promocode) ? items : [];
    }
    return items.filter(isPromocodeEligibleItem);
}

export function getPromocodeItem(
    items: Item[],
    promocode: Promocode,
    screeningId: string | null,
): Item | undefined {
    const eligibleItems = getPromocodeItems(items, promocode);
    return promocode.gift_target_ticket_id
        ? eligibleItems[0]
        : eligibleItems.find((item) => !!screeningId && item.screening?.id === screeningId);
}
